module.exports = __webpack_public_path__ + "img/Jc.4f60cab0.png";